import { request } from "../network/request";
const db = "dn0";

/**
 * 获取表单列表
 * @param {*} params
 * @returns
 */
 export function listMeta(params) {
    return request({
        url: "meta/listMeta",
        method: "get",
        params,
    });
}

/**
 * 获取表单信息
 * @param {*} params
 * @returns
 */
 export function getMeta(params) {
    return request({
        url: "meta/getMeta",
        method: "get",
        params
    });
}
/**
 * 保存表单信息
 * @param {*} params
 * @returns
 */
export function saveMeta(params) {
    return request({
      url: "meta/saveMeta",
      method: "post",
      data: params,
    });
}

/**
 * 删除表单信息
 * @param {*} params
 * @returns
 */
 export function deleteMeta(params) {
    return request({
        url: "meta/deleteMeta",
        method: "get",
        params
    });
}

/**
 * 获取属性列表
 * @param {*} params
 * @returns
 */
 export function listProp(params) {
    return request({
        url: "meta/listMetaProp",
        method: "get",
        params,
    });
}

/**
 * 获取属性信息
 * @param {*} params
 * @returns
 */
 export function getProp(params) {
    return request({
        url: "meta/getMetaProp",
        method: "get",
        params
    });
}
/**
 * 保存属性信息
 * @param {*} params
 * @returns
 */
export function saveProp(params) {
    return request({
      url: "meta/saveMetaProp",
      method: "post",
      data: params,
    });
}
